'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Divider } from '@heroui/react';
import { LucideAlertCircle } from 'lucide-react';
import Link from 'next/link';
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@/components/ui/empty';
import { APP_ROUTES } from '@/shared/constants/app-routes';
import { buildAppRoute } from '@/shared/functions/build-app-route';
interface PreRegisterAlreadyExistsStateProps {
  onReset: () => void;
}
export function PreRegisterAlreadyExistsState(t0) {
  const $ = _c(7);
  const {
    onReset
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <EmptyHeader><EmptyMedia variant="icon"><LucideAlertCircle /></EmptyMedia><EmptyTitle>Cadastro já existente</EmptyTitle><EmptyDescription className="max-w-md text-pretty">Já existe um pré-cadastro com este e-mail ou telefone. Se não foi você, verifique os dados e tente novamente.</EmptyDescription></EmptyHeader>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onReset) {
    t2 = <Button variant="solid" color="primary" className="w-full max-w-xs font-medium" onPress={onReset}>Tentar novamente</Button>;
    $[1] = onReset;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center gap-2 w-full justify-center"><Divider className="w-1/3 bg-secondary" /><span className="text-sm text-default-700">Precisa de ajuda?</span><Divider className="w-1/3 bg-secondary" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button as={Link} href={buildAppRoute(APP_ROUTES.EXTERNAL.SUPPORT)} type="button" className="w-full max-w-xs font-medium" variant="flat">Fale conosco</Button>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2) {
    t5 = <Empty className="w-full border border-dashed py-10">{t1}<EmptyContent>{t2}{t3}{t4}</EmptyContent></Empty>;
    $[5] = t2;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}